<template>
  <div :class="[$style.icon, $style[fillClass], $style[bgClass]]" class="mt-icon mt-icon-close" />
</template>

<script type="text/ecmascript-6">
import iconsMixins from './../icons.mixins'

export default {
  name: 'ErrorIcon',

  mixins: [iconsMixins],

  data () {
    return {
      defaultStatusFill: {
        icon: 'white',
        bg: 'red'
      }
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';
@import 'mpl-css/lib/assets/global/icons/icons-colors';

@import 'mpl-css/lib/assets/global/icons/icons-svg';

.icon {
  position: relative;
  width: rem(28);
  height: rem(28);
  border-radius: 50%;
  &::before {
    background-size: 60% 60%;
  }
}

@each $color, $value in $colors {
  .bg#{$color} {
    background-color: map-get($colors, $color);
  }
  .fill#{$color} {
    $close-fill: encodeHexColor(map-get($colors, $color));
    $closeIcon: getIconPngUrl('close', $close-fill);
    &::before {
      background-image: url($closeIcon);
    }
    &:hover,
    &:active {
      &::before {
        background-image: url($closeIcon);
      }
    }
  }
}
</style>
